import { isIOS, isMacOs, osVersion } from "react-device-detect";

export const isIOSWithDesktopVersionRequested = () => {
  return (( // Ipad is detected as a computer, if "desktop browser mode" is enabled in the Safari.
    isMacOs
    || global.window?.navigator?.vendor?.includes("Apple Computer")
    || global.window?.navigator?.vendor?.includes("Mac OS")
  ) && global.window?.navigator?.maxTouchPoints > 0);
};

const getOsVersionMajor = () => {
  let [major] = osVersion.split(".");
  return Number(major);
};

export const isIOSVersionUntil11 = () => {
  if (!isIOS) {
    return false;
  }

  if (isIOSWithDesktopVersionRequested()) {
    return false;
  }

  return getOsVersionMajor() < 11;
};

export const getIsIOSDevice = () => {
  if (isIOS) {
    return true;
  }

  return isIOSWithDesktopVersionRequested();
};
